import { animated } from 'react-spring';

export const AnimatedComponent = animated.div;
